"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedcancelanytimesm = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedcancelanytimesm` : '') + (description ? ` desc-brandedcancelanytimesm` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedcancelanytimesm"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedcancelanytimesm"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.4 10a10 10 0 1 1-20 0 10 10 0 0 1 20 0Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4 0v20a9.9 9.9 0 0 1-7.07-2.93A10.18 10.18 0 0 1 .42 10a9.96 9.96 0 0 1 3.06-7.21C5.48.89 7.83-.03 10.4 0Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.97 5.63c.5.5.5 1.3 0 1.8L7.8 14.6A1.27 1.27 0 0 1 6 12.8l7.18-7.17c.5-.5 1.3-.5 1.8 0Z",
    fill: "#FFF5EB"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M6 5.63c-.49.5-.49 1.3 0 1.8l7.18 7.17a1.27 1.27 0 0 0 1.8-1.8L7.8 5.63c-.5-.5-1.3-.5-1.79 0Z",
    fill: "#FFF5EB"
  }));
};
var _default = exports.default = brandedcancelanytimesm;